import React from 'react';
import { BlogPost } from '../../../types/blogPost';
import styled from 'styled-components';
import { VLink } from '../../other/vLink';
import { Block } from '../../other/block';

const BlogPostsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 3rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1531px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const BlogCTA = styled.a`
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #46ff46;
      transition: all .3s ease-in-out 0s;
      transform: scaleX(1);
    }
`;

const ViewMore = styled.a`
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #46ff46;
      transition: all .3s ease-in-out 0s;
      transform: scaleX(1);
    }
`;

interface BlogPostsProps {
  heading: string;
  introText: string;
  blogPosts: BlogPost[];
  backgroundColour?: string;
}

export const BlogPostCollection: React.FC<BlogPostsProps> = ({ heading, introText, blogPosts, backgroundColour }) => {
  return (
    <Block backgroundColour={backgroundColour}>
        <h2 className="mb-12 text-xl text-center uppercase">{heading}</h2>
        <div className="max-w-2xl mx-auto mb-16 text-lg text-center">{introText}</div>
        <BlogPostsContainer className="w-full mx-auto md:w-10/12">
        {blogPosts.map((blogPost, index) => (
          <div key={index} className="w-full mx-auto mb-0 sm:mb-0">
            <VLink to={`/${blogPost.slug}`}>
                <div className="overflow-hidden border border-stone">
                    <img className="object-cover w-full h-64" src={blogPost.mainImage.url} alt={blogPost.mainImage.name} />
                    <div className="flex flex-col justify-between h-auto md:h-48">
                        <div className="px-6 py-4">
                            <div className="mb-2 text-xl font-bold leading-tight">{blogPost.title}</div>
                            {blogPost.author && (
                                  <p className="text-base">By {blogPost.author.name}</p>
                                )
                            }
                        </div>
                        <div className="px-6 pt-4 pb-5">
                            <BlogCTA className="relative" href={`/${blogPost.slug}`}>
                                <span className="py-2 mb-2 text-lg uppercase">More</span>
                            </BlogCTA>
                        </div>
                    </div>
                </div>
            </VLink>
          </div>
        ))}
        </BlogPostsContainer>
        <div className="mx-auto mt-20 text-lg text-center uppercase">
            <ViewMore className="relative" href={`/blog`}>
                Read more blog posts
            </ViewMore>
        </div>
    </Block>
  );
};
